import {LoanEligibilityLogParams} from '../Model'
import {actionTypes} from './constants'

export const actions = {
  getLoanEligibilityLog: (params: LoanEligibilityLogParams = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_LOG_START,
    payload: params,
  }),
  getLoanEligibilityLogSuccess: (data: any) => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_LOG_SUCCESS,
    payload: data,
  }),
  getLoanEligibilityLogFinish: () => ({
    type: actionTypes.GET_LOAN_ELIGIBILITY_LOG_FINISH,
  }),
}
